import TemplatesComponent from "~/components/pages/supervisor/templates";

export default function TemplatesPage() {
  return <TemplatesComponent />;
}
